import _styled from "@emotion/styled-base";
import React from 'react';
import PropTypes from 'prop-types';
import Icon, { getIconColor } from '../Icon/Icon';
import Text from '../Text/Text';
import { elo as theme } from '../../themes';
import iconList from '../Icon/iconList';
import { jsx as ___EmotionJSX } from "@emotion/core";
var iconColor = function iconColor(_ref) {
  var item = _ref.item;
  var color = theme.colors.shade70;
  if (item != null && item.dimmed) {
    color = theme.colors.shade60;
  }
  if (item != null && item.brand) {
    color = theme.colors.brand30;
  }
  return color;
};
var StyledListItem = _styled("li", {
  target: "e1ktz4bl0"
})("display:flex;", function (_ref2) {
  var item = _ref2.item;
  return getIconColor(iconColor({
    item: item
  }));
}, " p{margin-left:", theme.spacings.xxxSmall, ";}:not(:last-of-type){margin-bottom:", function (props) {
  var _props$item;
  return (_props$item = props.item) != null && _props$item.small ? theme.spacings.xxxSmall : theme.spacings.xxSmall;
}, ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var List = function List(_ref3) {
  var items = _ref3.items;
  return ___EmotionJSX("ul", null, items.map(function (item, index) {
    return ___EmotionJSX(StyledListItem, {
      item: item,
      key: "item-" + index
    }, ___EmotionJSX(Icon, {
      type: (item == null ? void 0 : item.icon) || 'bullet'
    }), ___EmotionJSX(Text, {
      size: item != null && item.small ? 't3' : 't2',
      brand: item == null ? void 0 : item.brand,
      dimmed: (item == null ? void 0 : item.dimmed) && !item.brand
    }, item.label));
  }));
};
List.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    icon: PropTypes.oneOf([].concat(Object.keys(iconList), [''])),
    brand: PropTypes.bool,
    dimmed: PropTypes.bool,
    small: PropTypes.bool
  }))
};
export default List;